/* eslint-disable array-callback-return */

import { Fragment } from 'react';
import PropTypes from 'prop-types';
import { Box } from '@qga/roo-ui/components';
import * as propTypes from 'components/RefundBreakdown/propTypes';
import { FormattedCreditCard } from 'components/Formatters';
import LineItem from 'components/LineItem';

const CreditCardLineItem = ({ total, paymentMethods }) => (
  <LineItem title="Credit card" totals={[total]}>
    {paymentMethods.map((creditCard, index) => (
      <Box key={index}>
        Payment will be made with{' '}
        <strong>
          <FormattedCreditCard cardType={creditCard.cardType} lastFourDigits={creditCard.lastFourDigits} />
        </strong>
      </Box>
    ))}
  </LineItem>
);

const PointsLineItem = ({ total, paymentMethods }) => (
  <LineItem title="Qantas Points" totals={[total]}>
    {paymentMethods.map((points, index) => (
      <Box key={index}>
        Payment will be made with <strong>Qantas Frequent Flyer member {points.qffNumber}</strong>
      </Box>
    ))}
  </LineItem>
);

const PaymentBreakdown = ({ breakdown }) => (
  <Fragment>
    {breakdown.reduce((breakdownItems, breakdownItem) => {
      const { method } = breakdownItem;
      switch (method) {
        case 'credit_card':
          return [...breakdownItems, <CreditCardLineItem key={method} {...breakdownItem} />];
        case 'points':
          return [...breakdownItems, <PointsLineItem key={method} {...breakdownItem} />];
        default:
          return breakdownItems;
      }
    }, [])}
  </Fragment>
);

PaymentBreakdown.propTypes = {
  breakdown: PropTypes.arrayOf(propTypes.paymentBreakdownItem).isRequired,
};

export default PaymentBreakdown;
